import { render, staticRenderFns } from "./IconToastClose.vue?vue&type=template&id=5926202b&scoped=true&functional=true"
import script from "./IconToastClose.vue?vue&type=script&lang=js"
export * from "./IconToastClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5926202b",
  null
  
)

export default component.exports